export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14213.f42cdb74.jpg";